export default [
    {
        path: '/',
        name: 'list',
        component: () => import('@/views/Invoices/Invoices'),
    },
    {
        path: '/:id',
        name: 'detail',
        component: () => import('@/views/InvoiceDetail/InvoiceDetail'),
    },
    {
        path: '/:id/payment',
        name: 'payment',
        component: () => import('@/views/Payment/Payment'),
    },
    {
        path: '/payment/success',
        name: 'payment-success',
        component: () => import('@/views/PaymentSuccess/PaymentSuccess'),
    },
];
